<span>
  <span class="oi oi-magnifying-glass"></span>

  <input
    #inputText
    type="text"
    placeholder="Find {{ label }}..."
    (keyup)="detectChanges($event)"
    (change)="detectChanges($event)"
  />
</span>

<span *ngIf="filteredResults.length === 0">No results found...</span>
<ul>
  <li
    *ngFor="let result of filteredResults"
    (click)="toggleResultCheck(result.id, $event)"
  >
    <input
      type="checkbox"
      [checked]="result.selected"
      (change)="toggleResultCheck(result.id, $event)"
    />
    <span>{{ result.text }}</span>
  </li>
</ul>
